import { useState } from 'react';
import { Form } from 'antd';
import { FolderOutlined, FolderOpenOutlined, FileOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import './Vertical.scss';

const Vertical = ({ treeData }) => {
  const [expandedNodes, setExpandedNodes] = useState({});
  const [selectedNode, setSelectedNode] = useState(null);

  const toggleExpand = (parentName, nodeName) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [parentName]: prev[parentName] === nodeName ? null : nodeName,
    }));
    setSelectedNode(nodeName);
  };

  const renderTree = (nodes, form, parentName = '') => (
    <ul className="tree-list">
      {nodes.map((node) => {
        const isSelected = selectedNode === node.name;

        return (
          <li
            key={node.name}
            className={classNames('tree-list-item', { 'selected': isSelected })}
          >
            <div
              className="tree-parent-node"
              onClick={() => toggleExpand(parentName, node.name)}
            >
              <span className="tree-icon">
                {node.children.length > 0 ? (
                  expandedNodes[parentName] === node.name ? (
                    <FolderOpenOutlined />
                  ) : (
                    <FolderOutlined />
                  )
                ) : (
                  <FileOutlined />
                )}
              </span>
              <span>{node.name}</span>
            </div>
            {expandedNodes[parentName] === node.name && node.children.length > 0 && (
              <div className="tree-child-container">
                {renderTree(node.children, form, node.name)}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      <Form.Item name="functionality" noStyle />
      <Form.Item
        label="Functionality"
        shouldUpdate={(curr, prev) => prev.functionality !== curr.functionality}
      >
        {(form) => (
          <div className="tree-container">
            {renderTree(treeData, form)}
          </div>
        )}
      </Form.Item>
    </>
  );
};

export default Vertical;
